(function () {
  var FORM_SELECTOR = '.klaviyo-form-TxDcrJ';
  var SOURCE_ID = 'kc-g6he-signup-source';

  function getConfig() {
    var src = document.getElementById(SOURCE_ID);
    if (!src) return null;
    return {
      companyId: src.dataset.klaviyoCompany || 'JjFuzB',
      listId: (src.dataset.klaviyoList || '').trim(),
      source: src.dataset.klaviyoSource || 'G6 HE Early Access'
    };
  }

  function subscribeToKlaviyo(email, config) {
    if (!config || !config.listId) {
      console.warn('[G6 HE signup] Set Klaviyo list ID in theme section "G6 HE Signup Fallback".');
      return Promise.resolve();
    }

    var url =
      'https://a.klaviyo.com/client/subscriptions/?company_id=' +
      encodeURIComponent(config.companyId);

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: config.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  signup_page: 'G6 HE Early Access',
                  signup_tag: 'g6-he-early-access'
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: config.listId
            }
          }
        }
      }
    };

    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        revision: '2026-07-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (res.status !== 202 && !res.ok) {
        console.warn('[G6 HE signup] Klaviyo subscribe failed:', res.status, res.statusText);
      }
    }).catch(function (err) {
      console.warn('[G6 HE signup] Klaviyo subscribe error:', err);
    });
  }

  function bindForms() {
    document.querySelectorAll('[data-g6he-signup] form').forEach(function (form) {
      if (form.dataset.g6heBound === '1') return;
      form.dataset.g6heBound = '1';

      form.addEventListener('submit', function (e) {
        if (form.dataset.klaviyoSent === '1') return;

        e.preventDefault();
        var config = getConfig();
        var input = form.querySelector('input[name="contact[email]"]');
        var email = input && input.value.trim();

        if (!email) {
          form.dataset.klaviyoSent = '1';
          form.submit();
          return;
        }

        subscribeToKlaviyo(email, config).finally(function () {
          form.dataset.klaviyoSent = '1';
          form.submit();
        });
      });
    });
  }

  function takeSlot() {
    var src = document.getElementById(SOURCE_ID);
    if (!src) return null;
    return src.querySelector('[data-g6he-slot]');
  }

  function mountNativeForms() {
    var mounts = document.querySelectorAll(FORM_SELECTOR);
    if (!mounts.length) return;

    mounts.forEach(function (mount) {
      if (mount.dataset.g6heFallback === '1' && mount.querySelector('[data-g6he-slot]')) {
        return;
      }

      var slot = takeSlot();
      if (!slot) return;

      while (mount.firstChild) mount.removeChild(mount.firstChild);
      mount.appendChild(slot);
      mount.dataset.g6heFallback = '1';
    });
  }

  function guardAgainstKlaviyoOverwrite() {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (mount) {
      if (mount.dataset.g6heGuard === '1') return;
      mount.dataset.g6heGuard = '1';

      var observer = new MutationObserver(function () {
        var hasNative = mount.querySelector('[data-g6he-slot]');
        var foreign = Array.prototype.filter.call(mount.children, function (el) {
          return !el.hasAttribute('data-g6he-slot');
        });
        if (!foreign.length) return;

        foreign.forEach(function (el) {
          el.remove();
        });
        if (!hasNative) {
          var slot = takeSlot();
          if (slot) mount.appendChild(slot);
        }
        mount.dataset.g6heFallback = '1';
        bindForms();
      });

      observer.observe(mount, { childList: true, subtree: false });
    });
  }

  function start() {
    if (!document.querySelector(FORM_SELECTOR)) return;
    mountNativeForms();
    guardAgainstKlaviyoOverwrite();
    bindForms();
    setTimeout(function () {
      mountNativeForms();
      bindForms();
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
